import { Loader2 } from "lucide-react";

const LoadingIndicator = () => {
  return (
    <div className="h-full flex flex-col items-center justify-center gap-1.5 animate-pulse">
      <Loader2 className="animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Loading...</p>
    </div>
  );
};

export default LoadingIndicator;
